import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  parentIndex: number;
}

export default function ActivityPurchaseAddOnsTable(props: Props) {
  const { t } = useTranslation();

  const name = `approvalable.activityPurchases.${props.parentIndex}.activityPurchaseAddOns`;

  const _value = HOCWatchValue({
    keys: [name],
  });
  const value = _value[name];

  const columns = [
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 250,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={value}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
